import { render } from "./DirectoryConfig.vue?vue&type=template&id=7f04fd73"
import script from "./DirectoryConfig.vue?vue&type=script&lang=js"
export * from "./DirectoryConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__